import React from 'react';
import ChatInterface from './ChatInterface';
import './index.css';
import './fonts/fonts.css';
import { lazyView } from './lazyView';
import SlidingPanels from './SlidingPanels';

// Chat is the default page and stays in the main bundle; every other page loads on its own.
const NetworkMap = lazyView(() => import('./NetworkMap'));
const StationDirectory = lazyView(() => import('./StationDirectory'));
const SuikaGame = lazyView(() => import('./SuikaGame'));
const GrainDrop = lazyView(() => import('./GrainDrop'));
const Gallery = lazyView(() => import('./Gallery'));
const ScheduledTasks = lazyView(() => import('./ScheduledTasks'));
const ProfilePage = lazyView(() => import('./ProfilePage'));
const CompanyPage = lazyView(() => import('./CompanyPage'));
const PairLanding = lazyView(() => import('./PairLanding'));
const LoginPage = lazyView(() => import('./LoginPage'));
const Messages = lazyView(() => import('./Messages'));
const Settings = lazyView(() => import('./Settings'));


function App() {
  const path = window.location.pathname;

  let content;
  if (path === '/login') {
    // public-homepage: the login gate's landing page.
    content = <LoginPage />;
  } else if (path.startsWith('/admin')) {
    content = <NetworkMap />;
  } else if (path.startsWith('/dashboard')) {
    // station-directory-ui: the station browse page (signed-in since public-homepage).
    // Must stay ABOVE the ChatInterface fallback.
    content = <StationDirectory />;
  } else if (path.startsWith('/gallery')) {
    // card-gallery: the signed-in owner's private board of saved cards.
    content = <Gallery />;
  } else if (path.startsWith('/settings')) {
    // Settings: global settings (notifications first); Account keeps personal information.
    content = <Settings />;
  } else if (path.startsWith('/messages')) {
    // mailbox-menu: stations' messages to the signed-in person.
    content = <Messages />;
  } else if (path.startsWith('/scheduled')) {
    // scheduled-result-view: recurring tasks the user set up. Split from /tasks,
    // which now holds backgrounded chat questions — same component, same data,
    // opposite halves of one table (see MODES in ScheduledTasks.js).
    content = <ScheduledTasks mode="scheduled" />;
  } else if (path.startsWith('/tasks')) {
    // scheduled-tasks-page: the signed-in owner's home for background jobs. Also
    // serves /tasks/run/<id>, the target of the chat notification's link — which
    // is why the background half kept this path rather than moving.
    content = <ScheduledTasks mode="background" />;
  } else if (path.startsWith('/account') || path.startsWith('/profile')) {
    // The Account page (personal information + sign-in). /profile is its old address.
    content = <ProfilePage />;
  } else if (path.startsWith('/company')) {
    // company-page: the site's own copy, rendered from markdown the
    // Communication station holds.
    content = <CompanyPage />;
  } else if (path.startsWith('/pair/')) {
    // presto-qr-pairing: where a phone's NATIVE camera lands after scanning the code
    // on a screen. Deliberately a client route (no server handler), so it falls through
    // the SPA catch-all like every other page.
    content = <PairLanding />;
  } else if (path.startsWith('/game/grain')) {
    content = <GrainDrop />;
  } else if (path.startsWith('/game')) {
    content = <SuikaGame />;
  } else {
    content = <ChatInterface />;
  }

  return (
    <div className="App">
      {content}
    </div>
  );
}

export default App;